import React from 'react'
import BackLog from './BackLog/BackLog'
import Blocked from './stage/Blocked'
import Doing from './stage/Doing'
import Done from './stage/Done'
import Ready from './stage/Ready'
import Review from './stage/Review'
import { useDrop } from "react-dnd";
import Item from './Item'
import {
    teamsApi,
    useGetProjectsQuery,
} from "../../features/projects/projectsApi";
import { useSelector } from "react-redux";
import {useUpdateProjectMutation} from "../../features/projects/projectsApi";
import {
    useGetTeamsQuery,
} from "../../features/teams/teamsApi";
const ProjectsMain = () => {
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const { data:teams } = useGetTeamsQuery(loggedInUser.id) || {};

    const { data, isLoading, isError, error } = useGetProjectsQuery(teams && teams.map(a => a.id)) || {};
    const [updateProject ] =useUpdateProjectMutation();
    const { search } = useSelector((state) => state.project);

    const [{ isOver: isBacklogOver }, removeFromBacklog] = useDrop({
    accept: ["ready","doing","done","blocked","review"],
    drop:(item)=>updateProjectStage(item,'backlog'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const [{ isOver:isReadyOver }, removeFromReady] = useDrop({
    accept: ["backlog","doing","done","blocked","review"],
    drop:(item)=>updateProjectStage(item,'ready'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const [{ isOver:isDoingOver }, removeFromDoing] = useDrop({
    accept: ["backlog","ready","done","blocked","review"],
    drop:(item)=>updateProjectStage(item,'doing'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const [{ isOver:isReviewOver }, removeFromReview] = useDrop({
    accept: ["backlog","ready","doing","done","blocked"],
    drop:(item)=>updateProjectStage(item,'review'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const [{ isOver:isBlockedOver }, removeFromBlocked] = useDrop({
    accept: ["backlog","ready","doing","done","review"],
    drop:(item)=>updateProjectStage(item,'blocked'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const [{ isOver:isDoneOver }, removeFromDone] = useDrop({
    accept: ["backlog","ready","doing","blocked","review"],
    drop:(item)=>updateProjectStage(item,'done'),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    const updateProjectStage = (item,stage)=>{
    updateProject({
        id:item.id,
        teams:teams && teams.map(a => a.id),
        data:{
            stage:stage
        }
        });
    }
  return (
            <>
                <div className="px-10 mt-6">
                    <h1 className="text-2xl font-bold">Project Board</h1>
                </div>
                {isLoading && 
                 <h2 className=' text-center '> Loading . . .</h2>
                }
                {data && data.length > 0 &&
                    <div className="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
                        <BackLog data={data} InnerRef={removeFromBacklog} />
                        <Ready data={data}InnerRef={removeFromReady} />
                        <Doing data={data} InnerRef={removeFromDoing} />
                        <Review data={data} InnerRef={removeFromReview} />
                        <Blocked data={data} InnerRef={removeFromBlocked} />
                        <Done data={data} InnerRef={removeFromDone} />
                    </div>
                }
            </>
  )
}

export default ProjectsMain